import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Button,
  Drawer,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCartShopping,
  faAngleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "motion/react";
import SidebarDrawer from "./SidebarDrawer";
import symbol from "../assets/symbol_bg.png";
import logo from "../assets/name_bg.png";

const navItems = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Women", path: "/product_list/2" },
  { name: "Men", path: "/product_list/1" },
  { name: "Jewellery", path: "/product_list/3" },
  { name: "Contact", path: "/contact" },
  { name: "FAQ", path: "/faq" },
];

function AppNavbar() {
  const [dropdownData, setDropdownData] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const [hoveredButton, setHoveredButton] = useState(null);
  const [dynamicData, setDynamicData] = useState({});
  const [xOffset, setXOffset] = useState("");
  const MotionBox = motion.create(Box);
  const MotionAppBar = motion.create(AppBar);
  const navigation = useNavigate();

  const [open, setOpen] = useState(false);

  const location = useLocation();
  const currentPath = location.pathname;
  const showSidebar = currentPath === "/";

  const toggleDrawer = (newOpen) => {
    if (isDropdownOpen) {
      setIsDropdownOpen(false); // Ensure dropdown closes when drawer opens
    }
    setOpen(newOpen);
  };

  // async function getSubCategory() {
  //   try {
  //     const response = await fetch("https://app.thesoyara.com/index.php?r=api/type-list");
  //     const result = await response.json();

  //     if (result) {
  //       const groupedData = {
  //         Women: { Category: {} },
  //         Men: { Category: {} },
  //         Jewellery: { Category: {} },
  //       };

  //       result.forEach(item => {
  //         const key = item.name.trim().toLowerCase().replace(/\s+/g, "_");
  //         if (item.category_id === "1") {
  //           groupedData.Men.Category[key] = item.name;
  //         } else if (item.category_id === "2") {
  //           groupedData.Women.Category[key] = item.name;
  //         } else if (item.category_id === "3") {
  //           groupedData.Jewellery.Category[key] = item.name;
  //         }
  //       });

  //       setDynamicData(groupedData);
  //     }
  //   } catch (error) {
  //     alert("Something went wrong");
  //     console.error(error);
  //   }
  // }

  //   useEffect(() => {
  //     getSubCategory();
  //   }, []);

  const data = dynamicData;

  // const handleMenuOpen = (event, item) => {
  //   item === "Women" || item === "Jewellery" ? setXOffset(-30) : setXOffset(50);

  //   if (data[item]) {
  //     const buttonRect = event.currentTarget.getBoundingClientRect(); // Get button position
  //     setDropdownStyle({
  //       left: buttonRect.left,
  //     });
  //     setDropdownData(data[item]);
  //     setIsDropdownOpen(true);
  //     setHoveredButton(item);
  //   } else {
  //     setIsDropdownOpen(false);
  //     setDropdownData(null);
  //   }
  // };

  const naviagteComponent = (item) => {
    if (item === "About" || item === "Contact" || item === "FAQ") {
      let path = item.toLowerCase();
      navigation(`/${path}`);
    } else if (item === "Home") {
      navigation("/");
    }
  };

  // const handleMenuClose = () => {
  //   setIsDropdownOpen(false);
  //   setHoveredButton(null); // Track hovered button
  // };

  // const handleMenuItemClick = (item) => {
  //   console.log("Clicked:", item);
  //   handleMenuClose();
  // };

  // const [scrolled, setScrolled] = useState(false);

  // Track scroll position
  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY > 50) {
  //       setScrolled(true); // Apply shadow when scrolled down
  //     } else {
  //       setScrolled(false); // Remove shadow when at the top
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  // const renderDropdown = () => {

  //   if (!Object.keys(dynamicData).length) return null; // Or a loading spinner

  //   return (
  //     <motion.div
  //       initial={{ x: xOffset, opacity: 0 }}
  //       animate={{ x: 0, opacity: 1 }}
  //       transition={{ duration: 0.3, ease: "easeOut", delay: 0.2 }}
  //     >
  //       <Grid2 container spacing={3}>
  //         {Object.entries(dropdownData).map(([mainCategory, subcategories]) => (
  //           <Grid2 size={{ lg: 8 }} key={mainCategory}>
  //             <h4 className="main-category-title">{mainCategory}</h4>
  //             <ul
  //               style={{
  //                 margin: 0,
  //                 listStyle: "none",
  //               }}
  //             >
  //               {Object.entries(subcategories).map(([key, value]) => (
  //                 <li
  //                   className="subcategory-item"
  //                   key={key}
  //                   onClick={() => handleMenuItemClick(value)}
  //                 >
  //                   {value}
  //                 </li>
  //               ))}
  //             </ul>
  //           </Grid2>
  //         ))}
  //       </Grid2>
  //     </motion.div>
  //   );
  // };

  return (
    <Box sx={{ display: "flex" }}>
      {/* <MotionAppBar component="nav" className="navbar-container" */}
      <AppBar
        component="nav"
        className="navbar-container"

        // initial={{
        //   backgroundColor: "white", // Initial background
        //   boxShadow: "none", // No shadow at start
        //   padding: '12px 0'
        // }}
        // animate={{
        //   backgroundColor: scrolled ? "white" : "white", // Keep the background white
        //   boxShadow: scrolled
        //     ? "0px 4px 6px rgba(0, 0, 0, 0.1)" // Shadow when scrolled
        //     : "none", // No shadow when not scrolled
        //     padding: scrolled
        //     ? "0px" // Shadow when scrolled
        //     : "12px 0", // No shadow when not scrolled
        // }}
        // transition={{
        //   type: "spring", // Use spring-based animation for smooth effects
        //   stiffness: 150, // Spring stiffness: higher values = faster snap
        //   damping: 20, // Lower damping = more bouncy effect
        //   mass: 0.5, // Controls the weight of the animation
        //   ease: [0.22, 0.61, 0.36, 1],
        // }}
      >
        <Toolbar>
          {currentPath === "/" ? (
            <IconButton
              aria-label="open drawer"
              edge="start"
              onClick={() => toggleDrawer(true)}
              sx={{ mr: 2, display: { sm: "none" }, color: "#183153" }}
            >
              <FontAwesomeIcon icon={faBars} />
            </IconButton>
          ) : (
            <IconButton
              aria-label="go back"
              edge="start"
              onClick={() => navigation(-1)}
              sx={{ mr: 2, display: { sm: "none" }, color: "#183153" }}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </IconButton>
          )}
          {showSidebar && (
            <SidebarDrawer
              open={open}
              toggleDrawer={toggleDrawer}
              data={data}
            />
          )}

          {/* <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={() => toggleDrawer(true)}
            sx={{ mr: 2, display: { sm: "none" }, color: "#183153" }}
          >
            <FontAwesomeIcon icon={faBars} />
          </IconButton> */}
          {/* <SidebarDrawer open={open} toggleDrawer={toggleDrawer} data={data} /> */}

          <div style={{ flexGrow: 0.4 }}>
            <NavLink to="/" className="brand-link">
              <img
                src={symbol} // ✅ Update with your logo path
                alt="Site Logo"
                className="branding-symbol-img"
                style={{}}
              />
              <img
                src={logo} // ✅ Update with your logo path
                alt="Site Logo"
                className="branding-name-img"
                style={{}}
              />
            </NavLink>
          </div>

          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {navItems.map((item, index) =>
              item.path ? (
                <NavLink
                  key={item.name}
                  to={item.path}
                  className={({ isActive }) =>
                    isActive ? "navbar-btn active" : "navbar-btn"
                  }
                  onClick={() => naviagteComponent(item.name)}
                  // onMouseEnter={(e) => handleMenuOpen(e, item.name)}
                  // onMouseLeave={() => {
                  //   if (hoveredButton !== item.name) {
                  //     handleMenuClose();
                  //   }
                  // }}
                >
                  {item.name}
                </NavLink>
              ) : (
                <Button
                  className="navbar-btn"
                  key={item.name}
                  sx={{ color: "#fff" }}
                  onClick={() => naviagteComponent(item.name)}
                  // onMouseEnter={(e) => handleMenuOpen(e, item.name)}
                  // onMouseLeave={() => {
                  //   if (hoveredButton !== item.name) {
                  //     handleMenuClose();
                  //   }
                  // }}
                >
                  {item.name}
                </Button>
              )
            )}

            {/* Dropdown menu hide as per requirment */}

            {/* <AnimatePresence>
              {isDropdownOpen && (
                <MotionBox
                  initial={{ y: [5, 9], opacity: [0.6, 0] }}
                  animate={{
                    y: 0,
                    opacity: 1,
                    pointerEvents: "auto",
                    transition: { duration: 0.3, ease: "easeIn" },
                  }}
                  exit={{ y: [5, 9], opacity: [0.6, 0], pointerEvents: "none" }}
                  className="dropdown-container"
                  onMouseEnter={() => setIsDropdownOpen(true)} // Keep open when hovering over the dropdown
                  onMouseLeave={handleMenuClose} // Close when leaving the dropdown
                  sx={{
                    ...dropdownStyle,
                    pointerEvents: isDropdownOpen ? "auto" : "none",
                  }}
                >
                  {renderDropdown()}
                </MotionBox>
              )}
            </AnimatePresence> */}
          </Box>
          {/* <div style={{ flexGrow: 0.5 }}>
            <button
              style={{ float: "rigth" }}
              onClick={() => navigation(`/add_to_cart`)}
            >
              <Badge badgeContent={4} color="primary">
                <FontAwesomeIcon icon={faCartShopping} />
              </Badge>
            </button>
          </div> */}
        </Toolbar>
      </AppBar>
      {/* </MotionAppBar> */}
    </Box>
  );
}
export default AppNavbar;
